import { ReactElement } from "react"
import { useParams } from "react-router-dom"

import SingleDemandDeviceDisplay from "./singleDemandDeviceDisplay"
import DataLoadError from "../../components/fallback/dataLoadError"
import SingleDeviceSkeleton from "../../components/loading/skeletons/singleDeviceSkeleton"
import AppPaper from "../../components/surfaces/appPaper"
import { Datasets } from "../../constants/enums"
import useMultiFetcherGetDevice from "../../services/middleware/hooks/useMultiFetcherGetDevice"

interface IDemandUrlParams {
    deviceId: string
    dataset: Datasets
}

export const getDraftDataset = (dataset: Datasets): Datasets => {
    switch (dataset) {
        case Datasets.EVAC: {
            return Datasets.EVAC_DRAFT
        }
        case Datasets.EVDC: {
            return Datasets.EVDC_DRAFT
        }
        case Datasets.HP: {
            return Datasets.HP_DRAFT
        }
        case Datasets.EB: {
            return Datasets.EB_DRAFT
        }
        case Datasets.ACU: {
            return Datasets.ACU_DRAFT
        }
        case Datasets.TTR: {
            return Datasets.TTR_DRAFT
        }
        default: {
            return Datasets.EVAC_DRAFT
        }
    }
}

/**
 * Webpage showing single demand device summary page. Handles API and
 * asynchronous logic and passes it to display component. Relies on `deviceId`
 * url parameter.
 */
const SingleDemandDeviceDraft = (): ReactElement => {
    const { deviceId, dataset } = useParams<
        keyof IDemandUrlParams
    >() as IDemandUrlParams

    const draftDataset = getDraftDataset(dataset)

    const { data, isLoading, isError, mutate, isValidating } =
        useMultiFetcherGetDevice(deviceId, draftDataset)

    if (isLoading && !data) {
        return <SingleDeviceSkeleton />
    }
    if (isError) {
        return (
            <AppPaper>
                <DataLoadError />
            </AppPaper>
        )
    }
    if (!data) {
        return (
            <AppPaper>
                <h1>No data</h1>
            </AppPaper>
        )
    }
    return (
        <SingleDemandDeviceDisplay
            data={data}
            mutate={mutate}
            dataset={draftDataset}
            isLoading={isLoading}
            isValidating={isValidating}
        />
    )
}

export default SingleDemandDeviceDraft
